/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { Catalog } from "./catalog.model";
import { environment } from "../../../../environments/environments";

export class CatalogsService {
  public static readonly CATALOGS_ROUTE = `${environment.backendUrl}/si-registry/api/v1/catalogs`;

  private static readonly HTTP_OPTIONS = {
    method: "GET",
    headers: {
      accept: "application/json",
    },
    cache: "no-cache",
    credentials: "same-origin",
    referrerPolicy: "no-referrer",
  } as any;

  private readonly window: Window;

  constructor(window: Window) {
    this.window = window;
  }

  public getCatalogs(): Promise<Catalog[]> {
    return this.fetchCatalogs();
  }

  private async fetchCatalogs(): Promise<Catalog[]> {
    const response = await window.fetch(
      CatalogsService.CATALOGS_ROUTE,
      CatalogsService.HTTP_OPTIONS
    );
    return await response.json();
  }
}
